import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ReactComponent as TargetUndo } from '../../../assets/svg/undoTarget.svg';
import { ReactComponent as DeleteIcon } from '../../../assets/svg/DeleteIcon.svg';
import { getImage } from '../../../server/server-media';
import {
    deleteKvizPitanjeById,
    deletePitanjeById,
    deletePodoblastById,
    getKvizPitanjaByLekcijaId,
    getLekcijeAndPitanjaByPodoblastId,
    getOblastById,
    getPitanjaByLekcijaId,
    updateListeKvizPitanja,
    updateListePitanja,
} from '../../../server/server-kategorije-tree';

import { notif } from '../../utils/util';
import PodoblastButton from './PodoblastButton';
import AddPodoblastModal from './AddPodoblastModal';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { FaEdit } from 'react-icons/fa';
import AddPitanjeModal from './AddPitanjeModal';
import AddLekcijaModal from './AddLekcijaModal';
import AddKvizPitanjeModal from './AddKvizPitanjeModal';
import MDEditor from '@uiw/react-md-editor';

import 'katex/dist/katex.min.css';
import rehypeKatex from 'rehype-katex';
import remarkMath from 'remark-math';
import { MarkDownView } from '../../common/MarkDownView';
import Loading from '../../../utils/Loading';
import { importLekcijaPitanjaExcel, previewImportLekcijaPitanjaExcel } from '../../../server/server-kviz';

function SingleOblast() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [hoveredButton, setHoveredButton] = useState(false);
    const [oblast, setOblast] = useState<any>(null);

    const [addPodoblastModalOpen, setAddPodoblastModalOpen] = useState(false);
    const [addPitanjeModalOpen, setAddPitanjeModalOpen] = useState(false);
    const [addKvizPitanjeModalOpen, setAddKvizPitanjeModalOpen] = useState(false);
    const [addLekcijaModalOpen, setAddLekcijaModalOpen] = useState(false);

    const [podoblasti, setPodoblasti] = useState([]);
    const [lekcije, setLekcije] = useState([]);
    const [pitanja, setPitanja] = useState<any>([]);
    const [kvizPitanja, setKvizPitanja] = useState<any>([]);

    const [selectedPodoblast, setSelectedPodoblast] = useState<any>(null);
    const [selectedLekcija, setSelectedLekcija] = useState<any>(null);
    const [selectedPitanje, setSelectedPitanje] = useState<any>(null);
    const [selectedKvizPitanje, setSelectedKvizPitanje] = useState<any>(null);

    const [uploadingExcel, setUploadingExcel] = useState(false);
    const [excelErrors, setExcelErrors] = useState<any[]>([]);

    useEffect(() => {
        if (!!id) loadOblast();
    }, [id]);

    const loadOblast = async () => {
        const resp = await getOblastById(id);
        if (resp.status == 200) {
            setOblast(resp.data);
        }
    };

    const fetchLekcije = async (item: any) => {
        setSelectedPodoblast(item);
        const resp = await getLekcijeAndPitanjaByPodoblastId(item?.id);
        if (resp.status === 200) {
            setLekcije(resp.data);
        }
    };

    const fetchPitanja = async (item: any) => {
        // setSelectedLekcija(item);
        const resp = await getPitanjaByLekcijaId(item?.id);
        if (resp.status === 200) {
            setPitanja(resp.data);
        }
    };

    const fetchKvizPitanja = async (item: any) => {
        // setSelectedLekcija(item);
        const resp = await getKvizPitanjaByLekcijaId(item?.id);
        if (resp.status === 200) {
            setKvizPitanja(resp.data);
        }
    };

    const goBack = () => {
        navigate('/admin/oblast');
    };

    const removePodoblast = async (e: any, id: string) => {
        e.preventDefault();
        e.stopPropagation();
        const confirmDelete = window.confirm('Da li ste sigurni da želite da obrišete ovu podoblast?');

        if (!confirmDelete) return;
        const resp = await deletePodoblastById(id);
        if (resp.status === 200) {
            notif('Uspesno ste obrisali podoblast');
            loadOblast();
        }
    };

    const removePitanje = async (id: string) => {
        const confirmDelete = window.confirm('Da li ste sigurni da želite da obrišete ovo pitanje?');

        if (!confirmDelete) return; // Ako korisnik klikne "Cancel", prekini funkciju
        const resp = await deletePitanjeById(id);
        if (resp.status === 200) {
            fetchPitanja(selectedLekcija);
            notif('Uspesno ste obrisali pitanje');
        }
    };

    const removeKvizPitanje = async (id: string) => {
        const confirmDelete = window.confirm('Da li ste sigurni da želite da obrišete ovo kviz pitanje?');

        if (!confirmDelete) return; // Ako korisnik klikne "Cancel", prekini funkciju

        const resp = await deleteKvizPitanjeById(id);
        if (resp.status === 200) {
            fetchKvizPitanja(selectedLekcija);
            notif('Uspešno ste obrisali kviz pitanje');
        }
    };

    const closeAddPodoblastModal = () => {
        setSelectedPodoblast(null);
        setAddPodoblastModalOpen(false);
    };
    const openAddPodoblastModal = (item: any) => {
        setSelectedPodoblast(item);
        setAddPodoblastModalOpen(true);
    };

    const closeAddLekcijaModal = () => {
        setSelectedLekcija(null);
        setAddLekcijaModalOpen(false);
    };
    const openAddLekcijaModal = (item: any) => {
        setSelectedLekcija(item);
        setAddLekcijaModalOpen(true);
    };

    const closeAddPitanjeModal = () => {
        setSelectedPitanje(null);
        setAddPitanjeModalOpen(false);
    };
    const openAddPitanjeModal = (item: any) => {
        setSelectedPitanje(item);
        setAddPitanjeModalOpen(true);
    };

    const openAddKvizPitanjeModal = (item: any) => {
        setSelectedKvizPitanje(item);
        setAddKvizPitanjeModalOpen(true);
    };
    const closeAddKvizPitanjeModal = () => {
        setSelectedKvizPitanje(null);
        setAddKvizPitanjeModalOpen(false);
    };

    const updateRedosledPitanja = async (lista: any) => {
        const resp = await updateListePitanja(lista);
        if (resp.status == 201) {
            notif('Uspešno ste promenili raspored pitanja u listi!');
            setPitanja(resp.data);
        } else {
        }
    };

    const updateRedosledKvizPitanja = async (lista: any) => {
        const resp = await updateListeKvizPitanja(lista);
        if (resp.status == 201) {
            notif('Uspešno ste promenili raspored kviz pitanja u listi!');
            setKvizPitanja(resp.data);
        } else {
        }
    };

    const handleSelectPodoblasti = (item: any) => {
        if (selectedPodoblast !== null && selectedPodoblast?.id === item?.id) {
            setSelectedPodoblast(null);
            setSelectedLekcija(null);
            setSelectedPitanje(null);
            setLekcije([]);
            setPitanja([]);
            setKvizPitanja([]);
        } else if (selectedPodoblast !== null && selectedPodoblast?.id !== item?.id) {
            setSelectedPodoblast(item);
            fetchLekcije(item);
            setPitanja([]);
            setKvizPitanja([]);
            setSelectedLekcija(null);
            setSelectedPitanje(null);
        } else if (selectedPodoblast === null) {
            setSelectedPodoblast(item);
            fetchLekcije(item);
            setPitanja([]);
            setKvizPitanja([]);
            setSelectedLekcija(null);
            setSelectedPitanje(null);
        }
    };

    const handleSelectLekcija = (item: any) => {
        if (selectedLekcija !== null && selectedLekcija?.id === item?.id) {
            setSelectedLekcija(null);
            setSelectedPitanje(null);
            setPitanja([]);
            setKvizPitanja([]);
        } else if (selectedLekcija !== null && selectedLekcija?.id !== item?.id) {
            setSelectedLekcija(item);
            fetchPitanja(item);
            fetchKvizPitanja(item);
            setSelectedPitanje(null);
        } else if (selectedLekcija === null) {
            setSelectedLekcija(item);
            fetchPitanja(item);
            fetchKvizPitanja(item);
            setSelectedPitanje(null);
        }
    };

    const handleDrop = (droppedItem: any) => {
        // Ignore drop outside droppable container
        if (!droppedItem.destination) return;
        var updatedList = [...pitanja];
        // Remove dragged item
        const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);
        // Add dropped item
        updatedList.splice(droppedItem.destination.index, 0, reorderedItem);
        let newReorderList = updatedList.map((item, index) => {
            return { ...item, redosled: index + 1 };
        });
        // Update State
        updateRedosledPitanja(newReorderList);
    };

    const handleDropKvizPitanja = (droppedItem: any) => {
        // Ignore drop outside droppable container
        if (!droppedItem.destination) return;
        var updatedList = [...kvizPitanja];
        // Remove dragged item
        const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);
        // Add dropped item
        updatedList.splice(droppedItem.destination.index, 0, reorderedItem);
        let newReorderList = updatedList.map((item, index) => {
            return { ...item, redosled: index + 1 };
        });
        // Update State
        updateRedosledKvizPitanja(newReorderList);
    };

    const handleExcelUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;

        setUploadingExcel(true);
        setExcelErrors([]);

        try {
            // prvo samo pregled - ništa se ne upisuje
            const preview = await previewImportLekcijaPitanjaExcel(file);
            if (preview.status !== 200 && preview.status !== 201) {
                notif(preview.data?.message || 'Greška pri proveri Excel fajla');
                return;
            }
            if (!preview.data.success) {
                setExcelErrors(preview.data.errors);
                notif('Excel ima greške');
                return;
            }
            const { noviCount, azuriranjeCount } = preview.data;
            const confirmed = window.confirm(`Pronađeno: ${noviCount} novih pitanja, ${azuriranjeCount} izmena postojećih pitanja.\n\nPotvrdi uvoz?`);
            if (!confirmed) return;

            const result = await importLekcijaPitanjaExcel(file);

            if (!result.data.success) {
                setExcelErrors(result.data.errors);
                notif('Excel ima greške');
                return;
            }

            notif(result.data.message);
            fetchPitanja(selectedLekcija);
        } catch (error: any) {
            notif(error?.message || 'Greška pri importu Excel fajla');
        } finally {
            setUploadingExcel(false);
            e.target.value = '';
        }
    };

    return (
        <div className="bg-[#ECEBF8] h-full  overflow-y-auto flex flex-col items-center py-[30px]">
            <div className="bg-white max-w-[850px] xl:max-w-[1600px] xxl:max-w-[1600px] p-[30px] w-full rounded-[10px] flex flex-col ">
                <div className="flex flex-row w-full items-start gap-5">
                    <div className="flex-1">
                        <div className="flex items-center justify-between">
                            <div className="flex ">
                                <div
                                    className=" flex cursor-pointer mr-5 items-center justify-center bg-blueMedium hover:bg-blueDark  min-w-[56px] w-[56px] h-[56px] rounded-full"
                                    onClick={() => goBack()}
                                    onMouseEnter={() => setHoveredButton(true)}
                                    onMouseLeave={() => setHoveredButton(false)}
                                >
                                    <TargetUndo fill={hoveredButton ? '#FDDF6D' : '#FFFFFF'} />
                                </div>
                                <h1 className="font-bold text-blueMedium text-[40px]">Oblast: {oblast?.naziv}</h1>
                            </div>
                        </div>
                        <div className="flex flex-row justify-between gap-5 mt-5">
                            <div className="flex flex-col gap-2  w-[50%]">
                                {!!oblast?.kategorija && (
                                    <div className="flex flex-col">
                                        <p className="text-left font-bold text-blueMedium text-base">Kategorija: {oblast.kategorija.naziv} </p>
                                    </div>
                                )}
                                {!!oblast?.podkategorija && (
                                    <div className="flex flex-col">
                                        <p className="text-left font-bold text-blueMedium text-base">Podkategorija: {oblast.podkategorija.naziv} </p>
                                    </div>
                                )}
                                {!!oblast?.skupOblasti && (
                                    <div className="flex flex-col">
                                        <p className="text-left font-bold text-blueMedium text-base">Skup oblasti: {oblast.skupOblasti.naziv} </p>
                                    </div>
                                )}
                            </div>
                            <div className=" w-[50%]">
                                <div className="grid grid-cols-4 gap-3">
                                    {oblast?.oblastImages?.map((item: any, index: number) => (
                                        <div className="w-full max-w-[200px] flex border border-greyLight rounded-lg" key={index}>
                                            <img
                                                style={{ objectFit: 'cover', width: '100%', minHeight: 100, maxHeight: 100, borderRadius: 8 }}
                                                src={getImage(item?.image?.id)}
                                                alt=""
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="grid grid-cols-12 gap-3 h-full mt-3 ">
                            <div className="h-full overflow-auto col-span-3">
                                <div className="flex flex-row items-center justify-between h-[50px]">
                                    <label className="text-[16px] leading-5 text-black font-semibold ">
                                        Lista postojecih podoblasti <span>(ukupno {oblast?.podoblasti?.length})</span>{' '}
                                    </label>
                                    <button
                                        className={`px-1 h-[40px] flex items-center justify-center bg-white border border-black rounded-[4px]  cursor-pointer `}
                                        onClick={() => {
                                            openAddPodoblastModal(null);
                                        }}
                                    >
                                        <p className="text-[16px] leading-5 text-black font-semibold whitespace-nowrap">Nova podoblast</p>
                                    </button>
                                </div>
                                {oblast?.podoblasti
                                    ?.sort((a: any, b: any) => a.redosled - b.redosled)
                                    .map((item: any, index: number) => {
                                        return (
                                            <div
                                                className={` border border-black200 rounded-[4px] px-1 py-2 mt-1 flex flex-row items-center justify-between cursor-pointer ${
                                                    item.id === selectedPodoblast?.id ? 'bg-blueSuperLight' : 'bg-white'
                                                }`}
                                                key={index}
                                                onClick={() => handleSelectPodoblasti(item)}
                                            >
                                                <div className="flex-1">
                                                    <p className="text-[14px] leading-[18px]">
                                                        Naziv: <span className="font-bold">{item.naziv}</span>
                                                    </p>
                                                    <p className="text-[14px] leading-[18px]">Redosled: {item.redosled}</p>
                                                    <p className="text-[14px] leading-[18px]" style={{ color: item.visible ? 'black' : 'red' }}>
                                                        Vidljivo: {item.visible ? 'Da' : 'Ne'}
                                                    </p>
                                                </div>
                                                <div className="cursor-pointer" onClick={(e) => removePodoblast(e, item?.id)}>
                                                    <DeleteIcon />
                                                </div>
                                                <div
                                                    className=" cursor-pointer p-2 "
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        openAddPodoblastModal(item);
                                                    }}
                                                >
                                                    <FaEdit style={{ width: 20, height: 20 }} />
                                                </div>
                                            </div>
                                        );
                                    })}
                            </div>

                            {selectedPodoblast && (
                                <div className="h-full overflow-auto col-span-3">
                                    <div className="flex flex-row items-center justify-between  h-[50px]">
                                        <label className="text-[16px] leading-5 text-black font-semibold  ">
                                            Lista postojecih lekcija <span>(ukupno {lekcije?.length})</span>{' '}
                                        </label>
                                        <button
                                            className={`px-1 h-[40px] flex items-center justify-center bg-white border border-black rounded-[4px]  cursor-pointer `}
                                            onClick={() => {
                                                openAddLekcijaModal(null);
                                            }}
                                        >
                                            <p className="text-[16px] leading-5 text-black font-semibold whitespace-nowrap">Nova lekcija</p>
                                        </button>
                                    </div>
                                    {lekcije
                                        ?.sort((a: any, b: any) => a.redosled - b.redosled)
                                        .map((item: any, index: number) => {
                                            return (
                                                <div
                                                    className={` border border-black200 rounded-[4px] px-1 py-2 mt-1 flex flex-row items-center justify-between gap-1 cursor-pointer ${
                                                        item.id === selectedLekcija?.id ? 'bg-blueSuperLight' : 'bg-white'
                                                    }`}
                                                    key={index}
                                                    onClick={() => handleSelectLekcija(item)}
                                                >
                                                    <div className="flex-1">
                                                        <p className="text-[14px] leading-4">
                                                            Naziv: <span className="font-bold">{item.naziv}</span>
                                                        </p>
                                                        <p className="text-[14px] leading-4">Redosled: {item.redosled}</p>
                                                        <p className="text-[14px] leading-4" style={{ color: item.visible ? 'black' : 'red' }}>
                                                            Vidljivo: {item.visible ? 'Da' : 'Ne'}
                                                        </p>
                                                        {item.id === selectedLekcija?.id && (
                                                            <p className="text-[14px] leading-4">
                                                                Id: <span className="font-semibold text-greenA700">{item.id}</span>
                                                            </p>
                                                        )}
                                                    </div>

                                                    <div
                                                        className="cursor-pointer"
                                                        //onClick={() => removeKvizPitanje(item?.id)} todo postaviti preventDefault i stopPropagation jer je ispod klikabilno polje
                                                    >
                                                        <DeleteIcon />
                                                    </div>
                                                    <div
                                                        className=" cursor-pointer p-2 "
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            openAddLekcijaModal(item);
                                                        }}
                                                    >
                                                        <FaEdit style={{ width: 20, height: 20 }} />
                                                    </div>
                                                </div>
                                            );
                                        })}
                                </div>
                            )}
                            {!!selectedLekcija && (
                                <div className="h-full overflow-auto col-span-3">
                                    <div className="flex flex-row items-center justify-between gap-2">
                                        <p className="text-[14px] leading-4 text-black font-semibold ">
                                            Lista postojecih pitanja <span>(ukupno {pitanja.length})</span>{' '}
                                        </p>
                                        <button
                                            className={`px-[2px] h-[40px] flex items-center justify-center bg-white border border-black rounded-[4px]  cursor-pointer `}
                                            onClick={() => {
                                                openAddPitanjeModal(null);
                                            }}
                                        >
                                            <p className="text-[14px] leading-4 text-black font-semibold ">Dodaj novo pitanje</p>
                                        </button>
                                    </div>
                                    <label
                                        className={`px-4 h-[40px] flex items-center justify-center bg-green-200 border border-black rounded-[4px] cursor-pointer ${
                                            uploadingExcel ? 'opacity-50 cursor-not-allowed' : ''
                                        }`}
                                    >
                                        <input type="file" accept=".xlsx,.xls" onChange={handleExcelUpload} className="hidden" disabled={uploadingExcel} />
                                        {uploadingExcel ? (
                                            <div className="flex items-center gap-2">
                                                <Loading size={20} primaryColor="#5E639B" stroke={2} /> {/* tvoj spinner */}
                                                <span className="text-[14px] leading-4 text-black font-semibold">Učitavanje...</span>
                                            </div>
                                        ) : (
                                            <span className="text-[14px] leading-4 text-black font-semibold">Importuj iz Excel tabele pitanja</span>
                                        )}
                                    </label>
                                    <DragDropContext onDragEnd={handleDrop}>
                                        <Droppable droppableId="list-container">
                                            {(provided) => (
                                                <div {...provided.droppableProps} ref={provided.innerRef}>
                                                    {pitanja
                                                        .sort((a: any, b: any) => a.redosled - b.redosled)
                                                        .map((item: any, index: number) => {
                                                            return (
                                                                <Draggable key={index.toString()} draggableId={index.toString()} index={index}>
                                                                    {(provided) => (
                                                                        <div
                                                                            className="bg-white border border-black200 rounded-[4px] px-2 py-[6px] mt-1 flex flex-row items-center gap-2"
                                                                            key={index}
                                                                            ref={provided.innerRef}
                                                                            {...provided.draggableProps}
                                                                            {...provided.dragHandleProps}
                                                                        >
                                                                            <div className="flex-1">
                                                                                <p className="text-[14px] leading-4">
                                                                                    Naziv: <span className="font-bold">{item.naziv}</span>
                                                                                </p>
                                                                                <p className="text-[14px] leading-4">Redosled: {item.redosled}</p>
                                                                                <p
                                                                                    className="text-[14px] leading-4"
                                                                                    style={{ color: item.visible ? 'black' : 'red' }}
                                                                                >
                                                                                    Vidljivo: {item.visible ? 'Da' : 'Ne'}
                                                                                </p>
                                                                            </div>
                                                                            <div className="cursor-pointer" onClick={() => removePitanje(item?.id)}>
                                                                                <DeleteIcon />
                                                                            </div>
                                                                            <div
                                                                                className=" cursor-pointer p-2 "
                                                                                onClick={() => {
                                                                                    openAddPitanjeModal(item);
                                                                                }}
                                                                            >
                                                                                <FaEdit style={{ width: 20, height: 20 }} />
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </Draggable>
                                                            );
                                                        })}
                                                    {provided.placeholder}
                                                </div>
                                            )}
                                        </Droppable>
                                    </DragDropContext>
                                </div>
                            )}
                            {!!selectedLekcija && (
                                <div className="h-full overflow-auto col-span-3">
                                    <div className="flex flex-row items-center justify-between gap-2">
                                        <p className="text-[14px] leading-4 text-black font-semibold ">
                                            Lista postojecih kviz pitanja <span>(ukupno {kvizPitanja.length})</span>{' '}
                                        </p>
                                        <button
                                            className={`px-[2px] h-[40px] flex items-center justify-center bg-white border border-black rounded-[4px]  cursor-pointer `}
                                            onClick={() => {
                                                openAddKvizPitanjeModal(null);
                                            }}
                                        >
                                            <p className="text-[14px] leading-4 text-black font-semibold ">Dodaj novo kviz pitanje</p>
                                        </button>
                                    </div>
                                    <DragDropContext onDragEnd={handleDropKvizPitanja}>
                                        <Droppable droppableId="list-container">
                                            {(provided) => (
                                                <div {...provided.droppableProps} ref={provided.innerRef}>
                                                    {kvizPitanja
                                                        .sort((a: any, b: any) => a.redosled - b.redosled)
                                                        .map((item: any, index: number) => {
                                                            return (
                                                                <Draggable key={index.toString()} draggableId={index.toString()} index={index}>
                                                                    {(provided) => (
                                                                        <div
                                                                            className={` border border-black200 rounded-[4px] px-2 py-[6px] mt-1 flex flex-row items-center gap-2 ${
                                                                                item.isLekcijaPitanje && item.isKvizPitanje
                                                                                    ? 'bg-greenA200'
                                                                                    : item.isLekcijaPitanje && !item.isKvizPitanje
                                                                                      ? 'bg-greenA200'
                                                                                      : !item.isLekcijaPitanje && item.isKvizPitanje
                                                                                        ? 'bg-yellow-300'
                                                                                        : 'bg-redError'
                                                                            }`}
                                                                            key={index}
                                                                            ref={provided.innerRef}
                                                                            {...provided.draggableProps}
                                                                            {...provided.dragHandleProps}
                                                                        >
                                                                            <div className="flex-1">
                                                                                <p className="text-[14px] leading-4 line-clamp-2">
                                                                                    Redni broj {item.redosled}.
                                                                                </p>
                                                                                <MarkDownView source={item.naziv} show3Rows />

                                                                                <p className="text-[14px] leading-4">
                                                                                    Pitanje za lekciju: {item.isLekcijaPitanje ? 'DA' : 'NE'}
                                                                                </p>
                                                                                <p className="text-[14px] leading-4">
                                                                                    Pitanje za kviz: {item.isKvizPitanje ? 'DA' : 'NE'}
                                                                                </p>
                                                                                <p
                                                                                    className="text-[14px] leading-4"
                                                                                    style={{ color: item.visible ? 'black' : 'red' }}
                                                                                >
                                                                                    Vidljivo: {item.visible ? 'Da' : 'Ne'}
                                                                                </p>
                                                                            </div>
                                                                            <div className="cursor-pointer" onClick={() => removeKvizPitanje(item?.id)}>
                                                                                <DeleteIcon />
                                                                            </div>
                                                                            <div
                                                                                className=" cursor-pointer p-2 "
                                                                                onClick={() => {
                                                                                    openAddKvizPitanjeModal(item);
                                                                                }}
                                                                            >
                                                                                <FaEdit size={20} />
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </Draggable>
                                                            );
                                                        })}
                                                    {provided.placeholder}
                                                </div>
                                            )}
                                        </Droppable>
                                    </DragDropContext>
                                </div>
                            )}
                        </div>
                        {/* <div className='flex flex-col mt-4'>
							<div className='flex flex-row items-center justify-between'>
								<p className='text-left font-bold text-blueMedium text-2xl'>Podoblasti</p>
								<div
									className={`cursor-pointer flex h-[50px]  w-[180px] items-center justify-center rounded-full border border-blueMedium
									bg-white text-lg  font-semibold text-blueMedium transition  hover:bg-blueMedium hover:text-white`}
									onClick={() => {
										openAddPodoblastModal(null);
									}}
								>
									Dodaj podoblast
								</div>
							</div>
							<div className='mt-3'>
								{oblast?.podoblasti?.map((item: any, index: number) => (
									<PodoblastButton podoblast={item} handlePodoblastRemove={removePodoblast} key={item?.id} index={index} oblast={oblast} setOblast={setOblast} />
								))}
							</div>
						</div> */}
                    </div>
                </div>
            </div>
            <AddKvizPitanjeModal
                modalIsOpen={addKvizPitanjeModalOpen}
                closeModal={closeAddKvizPitanjeModal}
                lekcija={selectedLekcija}
                pitanjeId={selectedKvizPitanje?.id ?? null}
                reloadLekcije={() => fetchKvizPitanja(selectedLekcija)}
            />
            <AddPitanjeModal
                modalIsOpen={addPitanjeModalOpen}
                closeModal={closeAddPitanjeModal}
                lekcija={selectedLekcija}
                pitanjeId={selectedPitanje?.id}
                reloadLekcije={() => fetchPitanja(selectedLekcija)}
            />
            <AddLekcijaModal
                modalIsOpen={addLekcijaModalOpen}
                closeModal={closeAddLekcijaModal}
                podoblast={selectedPodoblast}
                lekcija={selectedLekcija}
                reloadLekcije={() => fetchLekcije(selectedPodoblast)}
            />
            <AddPodoblastModal
                modalIsOpen={addPodoblastModalOpen}
                closeModal={closeAddPodoblastModal}
                oblast={oblast}
                podoblast={selectedPodoblast}
                reloadPodkategorije={loadOblast}
            />
        </div>
    );
}

export default SingleOblast;
